// extracted by mini-css-extract-plugin
module.exports = {"propertyList":"PropertyList_propertyList___uEIT","propertyList__title":"PropertyList_propertyList__title__mynMS","propertyList__items":"PropertyList_propertyList__items__QWqLN"};